import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { useMaterialUIController } from 'context';
import { getCrmColors } from '@layouts/pages/CRM/kanban-board/crm-theme';

interface Props {
    title: string;
    onClick: () => void;
    busy?: boolean;
    disabled?: boolean;
}

/// O mesmo botão de planilha no quadro, no painel e nas campanhas.
export const ExportButton = ({ title, onClick, busy = false, disabled = false }: Props) => {
    const [controller] = useMaterialUIController();
    const cc = getCrmColors(controller.darkMode);

    return (
        <Tooltip title={title}>
            <span>
                <IconButton
                    onClick={onClick}
                    disabled={disabled || busy}
                    aria-label={title}
                    sx={{
                        height: '43px',
                        width: '43px',
                        bgcolor: cc.surfaceBg,
                        border: `1px solid ${cc.border}`,
                        borderRadius: '9px',
                        color: cc.textSecondary,
                        '&:hover': { bgcolor: cc.countBg },
                    }}
                >
                    {busy
                        ? <CircularProgress size={18} sx={{ color: cc.textSecondary }} />
                        : <FileDownloadOutlinedIcon fontSize="small" />}
                </IconButton>
            </span>
        </Tooltip>
    );
};
